import axios from "@/app/plugins/Axios";

function listar(paginacao) {
  return axios
    .get("variacoes", { params: paginacao })
    .then((response) => response.data);
}

function buscar(busca) {
  return axios
    .get(`variacoes/buscar?busca=${busca}`)
    .then((response) => response.data);
}

function buscarPorCodigo(codigo) {
  return axios
    .get(`variacoes/buscarCodigo?codigo=${codigo}`)
    .then((response) => response.data);
}

function abrir(id) {
  return axios.get(`/variacoes/${id}`).then((response) => response.data);
}

function salvar(variacao) {
  return axios.post("/variacoes", variacao).then((response) => response.data);
}

function atualizar(variacao) {
  return axios.put(`/variacoes/${variacao.id}`, variacao).then((response) => response.data);
}

function excluir(id) {
  return axios.delete(`/variacoes/${id}`).then((response) => response.data);
}

function listarValores(variacao_id) {
  return axios.get('/variacoes/valores', {params: {variacao_id: variacao_id}})
    .then(response => response.data);
}

function abrirValor(id) {
  return axios.get(`/variacoes/valores/${id}`)
    .then(response => response.data);
}

function salvarValor(valor) {
  return axios.post('/variacoes/valores', valor)
    .then(response => response.data);
}

function atualizarValor(valor) {
  return axios.put(`/variacoes/valores/${valor.id}`, valor)
    .then(response => response.data)
}

function excluirValor(id) {
  return axios.delete(`/variacoes/valores/${id}`)
    .then(response => response.data);
}

export default {
  listar,
  buscar,
  buscarPorCodigo,
  abrir,
  salvar,
  atualizar,
  excluir,
  listarValores,
  abrirValor,
  salvarValor,
  atualizarValor,
  excluirValor,
};
